import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, mergeProps as _mergeProps, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1eed57b4")
const _hoisted_1 = { class: "card-content px-0" }
const _hoisted_2 = { class: "level is-mobile" }
const _hoisted_3 = {
  class: "level-left",
  style: {"max-width":"80%"}
}
const _hoisted_4 = { class: "is-size-6 mb-0 has-text-black-bis has-text-weight-medium" }
const _hoisted_5 = { class: "is-size-7 has-text-black-bis has-text-weight-normal" }
const _hoisted_6 = {
  key: 0,
  class: "columns"
}
const _hoisted_7 = { class: "column is-fullwidth" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  class: "button is-info is-multiline is-activ",
  style: {"pointer-events":"none"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "is-size-7 has-text-black-bis has-text-weight-medium" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelItemComponent = _resolveComponent("LevelItemComponent")!
  const _component_IconsByImageCollection = _resolveComponent("IconsByImageCollection")!
  const _component_LevelComponent = _resolveComponent("LevelComponent")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: ["card", { selected: $props.focused }]
  }, _ctx.$attrs), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_LevelItemComponent, { class: "is-flex-direction-column is-align-items-flex-start" }, {
            default: _withCtx(() => [
              _createElementVNode("h6", _hoisted_4, _toDisplayString($props.title), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString($props.subtitle), 1)
            ]),
            _: 1
          })
        ])
      ]),
      (!$props.byName && $setup.readableDistance > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString($setup.readableDistance), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t($setup.isInMeters ? "m" : "km")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.taglist && $props.taglist.includes('ONLY_ACTIV'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('activ.banner')), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_10,
      _createVNode(_component_LevelComponent, null, _createSlots({
        "level-left": _withCtx(() => [
          _createVNode(_component_LevelItemComponent, { class: "is-flex-direction-column is-align-items-flex-start" }, {
            default: _withCtx(() => [
              _createVNode(_component_IconsByImageCollection, {
                icons: $props.icons,
                class: "is-small is-borderless"
              }, null, 8, ["icons"])
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        ($props.inRadius != undefined)
          ? {
              name: "level-right",
              fn: _withCtx(() => [
                _createElementVNode("p", _hoisted_11, _toDisplayString($props.inRadius) + " " + _toDisplayString(_ctx.$t("km")), 1)
              ])
            }
          : undefined
      ]), 1024)
    ])
  ], 16))
}